import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { RootState } from "../store";
import LocalStorageKeys from "../client-portal/common/enums/local-storage-keys";
import { setIsClientPortalUserAuthenticated } from "../slices/clientPortalAuthSlice";
import { routes } from "../constants";

export default function useLogoutListener(): void {
  const history = useHistory();
  const isClientPortal = useSelector((rootState: RootState) => rootState.isClientPortal);
  const dispatch = useDispatch();
  const { clientPortal } = routes;
  const loginRoute = `${clientPortal.name}/${clientPortal.subRoutes.login.name}`;
  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      // Check if the user key is removed from localStorage
      if (event.key === LocalStorageKeys.USER && !event.newValue) {
        // Redirect to the login page
        if (isClientPortal) {
          dispatch(setIsClientPortalUserAuthenticated(false));
          history.push(loginRoute);
        } else {
          history.push("/login");
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [history, isClientPortal, dispatch, loginRoute]);
}
